import { render } from "./ConsultaFormulariosHistorico.vue?vue&type=template&id=2947c1be"
import script from "./ConsultaFormulariosHistorico.vue?vue&type=script&lang=js"
export * from "./ConsultaFormulariosHistorico.vue?vue&type=script&lang=js"

import "./ConsultaFormulariosHistorico.vue?vue&type=style&index=0&id=2947c1be&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__